// @flow
import React from 'react'
import mustache from 'mustache'

mustache.escape = value => value

import LoadableHtmlRender from './LoadableHtmlRender'

// core
import { getValueForPath } from '../FilterFunctions'

// components
import { Alert } from '../../Components/_textBlockComponents/'

// types
import type { ValueObject } from '../Types/Values'

type TextBlockProps = {
  alerts: ValueObject,
  blocks: ValueObject,
  debug?: boolean,
  documentsHtml: string,
  templateVariables?: ValueObject,
  textOrder: Array<string>,
}

type TextBlockState = {
  rawBlocks: ValueObject,
  blocks: ValueObject,
}

const getVariableFromBlock = (props, blocks) => {
  let variables = {
    alerts: props.alerts,
    blocks,
  }
  return Object.assign(variables, props.templateVariables)
}

export default class TextBlock extends React.Component<TextBlockProps, TextBlockState> {
  static defaultProps = {
    debug: false,
    templateVariables: {},
  }

  static getDerivedStateFromProps = (nextProps: TextBlockProps, prevState: TextBlockState) => {
    if (JSON.stringify(nextProps.blocks) !== JSON.stringify(prevState.rawBlocks)) {
      const renderedBlockNames = []
      const blocksToRender = [...Object.keys(nextProps.blocks)]
      const renderedBlocks = {}

      if (blocksToRender.length === 0) {
        return null
      }

      let index = 0
      while (blocksToRender.length > index && index < 100) {
        let variables = getVariableFromBlock(nextProps, renderedBlocks)
        let blockName = blocksToRender[index]
        const match = blockName.match(/{{(blocks.[a-zA-Z0-9]*)}}/g)
        const canRender = !match || match.reduce((acc, matchItem) =>
          acc && renderedBlockNames.includes(matchItem.replace('{{blocks.', '').replace('}', ''))
        , true)
        if (canRender) {
          renderedBlocks[blockName] = mustache.render(nextProps.blocks[blockName], variables)
        } else {
          blocksToRender.push(blockName)
        }
        index++
      }
      return {
        rawBlocks: nextProps.blocks,
        blocks: renderedBlocks,
      }
    }
    return null
  }

  state = {
    rawBlocks: {},
    blocks: {},
  }

  getContentForPath = (path: string | Array<string>) => {
    return getValueForPath(path, 0, this.props)
  }

  render = () => {
    const variables = getVariableFromBlock(this.props, this.state.blocks)
    return (
      this.props.textOrder.map((textPath) => {
        let content = this.getContentForPath(textPath)
        if (textPath.indexOf('alerts') === 0) {
          return (
            <div key={textPath}>
              {this.props.debug && <span className='text-secondary'>
								Text: {textPath}
							</span>}
              <Alert
                text={<LoadableHtmlRender label={mustache.render(content.text, variables)} />}
                type={content.type}
              />
            </div>
          )
        } else if (textPath.indexOf('blocks') === 0) {
          if (content.includes('{documents}')) {
            content = content.replace('{documents}', this.props.documentsHtml)
          }
          if (content) {
            return (
              <div key={textPath}>
                {this.props.debug && <span className='text-secondary'>
									Text: {textPath}
								</span>}
                <LoadableHtmlRender label={mustache.render(content, variables)} />
              </div>
            )
          }
        }
        return null
      })
    )
  }
}
